import React, { useState, useEffect } from "react";

import { getAllBusRoutes } from "../Requests/MapRequests";
import MultiSelect from "../Components/MultiSelect";

const BusMapFilter = (props) => {

    const [routes, setRoutes] = useState([]);
    const [newRoute, setNewRoute] = useState("");
    const [selectedRoutes, setSelectedRoutes] = useState([]);

    useEffect(() => {
        getAllBusRoutes()
        .then(({data}) => {
            setRoutes(data.map(r => r.BusRouteID));

            if(props.filterValue && props.filterValue){
                setSelectedRoutes(props.filterValue);
            }
        });
    }, []);

    const runFilter = () => {
        props.applyFilter(selectedRoutes);
    }

    const runReset = () => {
        setSelectedRoutes([]);
    }

    const updateSelections = (s) => {
        setSelectedRoutes(s.target.value);
    }

    const changeNewRoute = (evt) => {
        setNewRoute(evt.target.value);
    }

    const addRoute = () => {
        const copy = [...selectedRoutes];
        copy.push(newRoute);
        setNewRoute("");
        setSelectedRoutes(copy);
    }

    const removeRoute = (r) => {
        const copy = selectedRoutes.filter(sr => {
            return (sr !== r);
        });

        setSelectedRoutes(copy);
    }

    return (
        <div style={{
            position: "absolute",
            // top: "10vh",
            left: "0",
            zIndex: "10",
            backgroundColor: "white",
            width: "100vw",
            padding: "1rem"
        }}>
            <div style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                padding: "1rem"
            }}>
                <span style={{
                    fontSize: "1.3rem"
                }}>
                    Bus Map Route Filter
                </span>

                <div style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "space-evenly"
                }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem"
                    }}>
                        <input type="text" value={newRoute} onChange={changeNewRoute} />
                        <button className="option" onClick={addRoute}>Add Route</button>
                    </div>

                    <div className="map-filer-list">
                    {
                        selectedRoutes.map((r, i) => {
                            return (
                                <div className="map-filter-item" key={"selected_" + i}>
                                    {r}
                                    <span className="map-filter-remove" onClick={() => removeRoute(r)}></span>
                                </div>
                            )
                        })
                    }
                    </div>


                </div>
            </div>

            {
                selectedRoutes.length > 0
                ? <div className="filter-bar">
                    <div className="option  " onClick={runReset}>Reset</div>
                    <div id="busops_apply_filter" className="option  " onClick={runFilter}>Apply Filter</div>
                </div>
                : <div></div>
            }
        </div>
    );
}

export default BusMapFilter;